import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import * as actions from "./../../actions/index";
import { selectFilterItems, selectSearchTerm } from "./../../selectors.js";
import { API_URL, ApiConfig } from "./../../settings";

import "./style.css";
import GpsIcon from "./../../images/location-white.svg";
import FilterOptions from "./../../containers/FilterOptions";

class PageHeader extends Component {
    constructor() {
        super();

        this.state = {
            locationText: "Finn kirker i nærheten",
            backgroundImage: null,
        };

        this.setSearchTerm = this.setSearchTerm.bind(this);
        this.filterOptionSelect = this.filterOptionSelect.bind(this);
        this.getCurrentPosition = this.getCurrentPosition.bind(this);
    }

    componentDidMount() {
        const { searchTerm } = this.props;
        if (searchTerm) this.searchTerm.value = searchTerm;
        else this.searchTerm.value = "";

        this.getBackgroundImage();
    }

    componentDidUpdate(prevProps) {
        const prevUrl = prevProps.location.pathname;
        const thisUrl = this.props.location.pathname;

        if (prevUrl !== thisUrl && thisUrl) {
            const keepRedux =
                thisUrl.includes("/sok") || thisUrl.includes("/kirke/");
            if (!keepRedux) this.searchTerm.value = "";
        }
    }

    setSearchTerm(clicked, e) {
        if (clicked || e.charCode === 13) {
            const term = this.searchTerm.value;
            this.props.setSearchTerm(term); // Add to redux store
            this.props.history.push("/sok");
            this.searchTerm.blur();
        }
    }

    getCurrentPosition() {
        this.setState({ locationText: "Finner din posisjon..." });
        this.props.history.push("/sok");

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.props.setUserLocation(location); // Add to redux store
                this.setState({ locationText: "Din posisjon er funnet" });
            },
            () => {
                console.error("Fikk ikke tilgang til lokasjonen");
                this.setState({ locationText: "Fant ikke posisjonen din" });
            }
        );
    }

    filterOptionSelect(value, key, selected, type, radio = null) {
        // Every time a filter option is clicked
        const { filterItems } = this.props;

        let newFilterData;

        // If radiobutton, replace instead of adding
        if (radio && selected) {
            const checkedItems = filterItems.filter(
                (item) => item.type !== type
            );
            newFilterData = [{ value, key, type }, ...checkedItems];
        } else if (selected && !radio) {
            newFilterData = [{ value, key, type }, ...filterItems];
        } else {
            newFilterData = filterItems.filter((item) => item.key !== key);
        }

        this.props.setFilterItems(newFilterData);

        if (type === "County") {
            const selectedCounties = newFilterData.filter(
                (item) => item.type === "County"
            );
            this.updateMunicipalities(selectedCounties, newFilterData);
        }
    }

    updateMunicipalities(counties, currentFilterData) {
        if (counties.length === 0) {
            this.props.setMunicipalities([]);
            const withoutMunicipalities = currentFilterData.filter(
                (item) => item.type !== "Municipality"
            );
            if (withoutMunicipalities.length !== currentFilterData.length) {
                this.props.setFilterItems(withoutMunicipalities);
            }
            return;
        }

        const query = counties
            .map(
                (county) =>
                    `county=${encodeURIComponent(county.value)}`
            )
            .join("&");

        axios
            .get(
                `${API_URL}/api/churches/filter/municipality?${query}`,
                ApiConfig
            )
            .then((res) => res.data)
            .catch(() => [])
            .then((names) => {
                const merged = [...new Set(names)].sort();
                const municipalities = merged.map((name) => ({
                    key: name,
                    value: name,
                }));
                this.props.setMunicipalities(municipalities);

                const availableSet = new Set(merged);
                const updated = currentFilterData.filter(
                    (item) =>
                        item.type !== "Municipality" ||
                        availableSet.has(item.key)
                );
                if (updated.length !== currentFilterData.length) {
                    this.props.setFilterItems(updated);
                }
            });
    }

    getBackgroundImage() {
        axios
            .get(
                "https://res.cloudinary.com/kirkesok/image/list/background.json"
            )
            .then((res) => {
                if (res.data.resources && res.data.resources.length > 0) {
                    const firstImage = res.data.resources[0];
                    const imageUrl = `https://res.cloudinary.com/kirkesok/image/upload/${firstImage.public_id}`;
                    this.setState({ backgroundImage: imageUrl });
                }
            })
            .catch((err) => {
                console.error("Error fetching background image", err);
            });
    }

    render() {
        const { backgroundImage } = this.state;
        const url = this.props.location.pathname;

        return (
            <div
                className="page-header"
                style={{
                    backgroundImage: `url(${url === "/" && backgroundImage})`,
                }}
            >
                <div className="container page-header__content">
                    <h4
                        className="page-header__instruction"
                        visibility="hidden"
                    >
                        Søk etter kirke eller bruk filtrene under.
                    </h4>

                    <div className="page-header-search">
                        <input
                            className="page-header-search__search-input"
                            ref={(comp) => {
                                this.searchTerm = comp;
                            }}
                            onKeyPress={(e) => this.setSearchTerm(false, e)}
                            placeholder="Søk etter kirker..."
                            type="text"
                            name="Søk etter kirker - skriv inn tekst"
                        />

                        <input
                            className="page-header-search__search-btn"
                            onClick={() => this.setSearchTerm(true)}
                            type="submit"
                            value="Søk"
                        />
                    </div>
                    <div className="page-header-location">
                        <span
                            id="getUserLocation"
                            onClick={this.getCurrentPosition}
                            tabIndex=""
                        >
                            <img
                                width="15px"
                                height="15px"
                                src={GpsIcon}
                                alt="GPS ikon for lokasjon"
                            />
                            {this.state.locationText}
                        </span>
                    </div>

                    <FilterOptions select={this.filterOptionSelect} />
                </div>
            </div>
        );
    }
}

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
        setUserLocation: (location) =>
            dispatch(actions.setUserLocation(location)),
        setFilterItems: (items) => dispatch(actions.setFilterItems(items)),
        setMunicipalities: (municipalities) =>
            dispatch(actions.setMunicipalities(municipalities)),
    };
};

const mapStateToProps = createStructuredSelector({
    filterItems: selectFilterItems(),
    searchTerm: selectSearchTerm(),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PageHeader)
);



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js